<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M1.5 4h21v15h-21V4z"/>
  <path stroke="#000" d="M1.5 4L12 13l10.5-9"/>
</svg>
